if(typeof FN == 'undefined') FN = {};


FN.contactForm = {
  requestTimeout: false,
  selectors: {
    formId: 'contact-form',
    formRowClass: 'contact-form__row',
    statusMessageClass: 'contact-form__status',
    dragDropUploadClass: 'contact-form__upload',
    dragDropUploadRemoveButtonClass: 'dragDropUpload__removeButton',
    dragDropUploadFileItemClass: 'dragDropUpload__fileItem',
    dragDropUploadFileNameClass: 'dragDropUpload__fileName',
    honeypotSelector: '#field-hp_consent',
  },
  constants: {
    requiredFields: ['message', 'name', 'email', 'legal'],
    sendingMessage: "Your message is being sent...",
    incompleteMessage: "Please fill all required (*) fields.",
    invalidEmailMessage: "Please provide a valid email address.",
    successMessage: "Thank you! We have received your request.",
    errorMessage: "An error occurred. Please contact support@git-tower.com via email!",
    acceptPrivacyPolicyMessage: "Please read and accept our Privacy Policy.",
    honeypotFilledMessage: "Please don't enter anything into the honeypot field."
  },
  contactTypes: [
    { 'type': 'Support Question',
      'name':'Support Question',
      'showFields': ['form-subject', 'form-user_name', 'form-user_email', 'form-message', 'form-upload', 'form-attachment', 'form-os_version', 'form-tower_version', 'form-git_version', 'form-legal'],
      'messageHelpText':"<em>When sending us a message, it's best to</em> <ul><li>include only one issue per support request</li><li>write a short but descriptive summary.</li></ul>"},
    { 'type': 'Sales Issue',
      'name':'Sales Issue',
      'showFields': ['form-subject', 'form-user_name', 'form-user_email', 'form-message', 'form-upload', 'form-attachment', 'form-legal'],
      'messageHelpText':"<em>When sending us a message, please</em><ul><li>include your order number, if you have any</li></ul>"},
    { 'type': 'Bug Report',
      'name':'Bug Report',
      'showFields': ['form-help-prefill', 'form-subject', 'form-user_name', 'form-user_email', 'form-message', 'form-bug-report-upload', 'form-attachment', 'form-os_version', 'form-tower_version', 'form-git_version', 'form-machine-id', 'form-legal'],
      'messageHelpText':"<em>When sending us a message, it's best to</em><ul><li>include only one issue per support request</li><li>describe the bug in detail but don't write an epic story</li><li>describe the steps to reproduce the error</li><li>tell us what you expected and what happened instead</li></ul>"},
    { 'type': 'Feature Request',
      'name':'Feature Request / Feedback',
      'showFields': ['form-subject', 'form-user_name', 'form-user_email', 'form-message', 'form-upload', 'form-attachment', 'form-legal'],
      'messageHelpText':"<em>When sending us a message, it's best to</em><ul><li>include only one feature per request</li><li>describe the feature in detail but don't write an epic story</li><li>describe your use case and how you would expect the feature to work</li></ul>"}
  ],
  bugReportTemplate: 'General description:\n<tell us more about the issue>\n\nStep to reproduce (try to be as detailed as possible, attach screenshots):\n- <first step>\n- <second step>\n\nExpected result:\n<what should happen>\n\nActual result:\n<what actually happened>\n\nActive integrations:\n<If applicable please list your active integrations (GitHub, GitLab, Bitbucket, etc.)>',
  fileAttachments: [],
  helpSuggestions: {
    utmLinking: {
      source: 'tower-website',
      campaign: 'contact',
      medium: 'help-suggestions'
    }
  },


  init: function() {
    var formElement = $('#' + FN.contactForm.selectors.formId);
    if(formElement.length == 0) return;

    // set form action dynamically to avoid spam bots
    // formElement.attr('action', 'http://localhost:8888/website-api/public/ticket/support/create');
    formElement.attr('action', FN.config.urls.apiBase + FN.config.urls.apiTicketSupport);

    // activate automatic help suggestions when users type the "subject"
    FN.contactForm.initHelpSuggestions();

    // form type selector
    FN.contactForm.insertFormTypeOptions();
    $('#form-type select').change(function(){
      FN.contactForm.showFormType($(this).val());
    });

    // build drag & drop form element
    FN.contactForm.buildDragDropElement();

    // initialize collapsible sections for help instructions
    FN.contactForm.initCollapsibleSections();

    // form submission
    $(formElement).on('submit', function(event){
      if(!FN.contactForm.isFormValid()) return false;
      if(FN.contactForm.isAdvancedUpload()) event.preventDefault();

      FN.contactForm.submitForm($(this), event);
    });

    // Determine if we should auto-select Bug Report based on URL parameters
    var requestTicketType = FN.helpers.getURLParameterByName('category');
    var towerVersion = FN.helpers.getURLParameterByName('tower_version');
    var gitVersion = FN.helpers.getURLParameterByName('git_version');
    var osVersion = FN.helpers.getURLParameterByName('os_version');
    var userEmail = FN.helpers.getURLParameterByName('email');

    // Auto-select Bug Report if parameters suggest the form is opened from Tower
    if (requestTicketType) {
      // If category is explicitly specified, use that
      $('#form-type select').val(requestTicketType);
      FN.contactForm.showFormType(requestTicketType);
    } else if (towerVersion && gitVersion && osVersion && userEmail) {
      // If we have app-provided data but no category, default to Bug Report
      $('#form-type select').val('Bug Report');
      FN.contactForm.showFormType('Bug Report');
    }
  },

  initCollapsibleSections: function() {
      $('.collapsible-button').on('click', function() {
        $(this).toggleClass('active');
        var content = $(this).next('.collapsible-content');
        if (content.css('max-height') !== '0px') {
          content.css('max-height', '0px');
        } else {
          content.css('max-height', content.prop('scrollHeight') + 'px');
        }
      });
    },

  insertFormTypeOptions: function(){
    var optionsHtml = "";
    optionsHtml += '<option value="">----</option>';
    for(var i=0; i<FN.contactForm.contactTypes.length; i++){
      optionsHtml += '<option value="' + FN.contactForm.contactTypes[i].type + '">' + FN.contactForm.contactTypes[i].name + '</option>'+"\n";
    }
    $('#form-type select').html(optionsHtml);
  },


  showFormType: function(formTypeIdentifier){
    FN.contactForm.prefillFormFields();
    FN.contactForm.showIntro(formTypeIdentifier);

    var formConfig = FN.contactForm.formConfigWithType(formTypeIdentifier);

    // Show/hide the section headers based on form type
    if (formTypeIdentifier === 'Bug Report') {
      // Show all h2 with class="contact-form-heading"
      $('h2.contact-form-heading').show();
      // Change subject label to "Summary of the Issue*"
      $('#form-subject label').text('Summary of the Issue*');
      // Prefill bug report textarea with template
      $('#form-message textarea').val(FN.contactForm.bugReportTemplate);
    } else {
      // Hide all h2 with class="contact-form-heading" for other form types
      $('h2.contact-form-heading').hide();
      // Reset subject label to "Subject*"
      $('#form-subject label').text('Subject*');
      // Clear bug report textarea
      $('#form-message textarea').val('');
    }

    // show fields
    $('.' + FN.contactForm.selectors.formRowClass).hide();
    $('#form-hint, #form-submit, #form-intro').show();
    for(var f=0; f<formConfig.showFields.length; f++){
      $('#'+formConfig.showFields[f]).show();
    }
    // replace messageHelpText
    $('#form-message .contact-form__aux').html(formConfig.messageHelpText).show();
  },


  buildDragDropElement: function(){
    var dragDropElement = $('.' + FN.contactForm.selectors.dragDropUploadClass);
    var dragDropLabel = (FN.contactForm.isAdvancedUpload()) ? '<strong>Choose a file</strong><span> or drag &amp; drop it here</span>.' : '<strong>Choose a file</strong>.'
    var html = '<input type="file" name="files[]" id="file" class="dragDropUpload__file" multiple>';
    html    += '<label for="file">'+ dragDropLabel +'</label>';
    html    += '<div class="box__files"></div>';

    $(dragDropElement).html(html);

    var input = $(dragDropElement).find('input');
    $(input).css({ width: '0.1px', height: '0.1px', opacity: 0, overflow: 'hidden', position: 'absolute', 'zindex': -1 });
    $(input).on('change', function(event){
      FN.contactForm.addFiles(event.target.files);
      FN.contactForm.showAddedFiles();
    });
    $(document).on('click', '.' + FN.contactForm.selectors.dragDropUploadRemoveButtonClass, function(event){
      FN.contactForm.removeFiles($(this));
    });

    FN.contactForm.handleDragDropEvents();
  },


  addFiles: function(files){
    for(var f=0; f<files.length; f++){
      FN.contactForm.fileAttachments.push(files[f]);
    }
  },


  removeFiles: function(clickedEl){
    var fileName = $(clickedEl).closest('li').find('.'+FN.contactForm.selectors.dragDropUploadFileNameClass).text();

    for(var f=0; f<FN.contactForm.fileAttachments.length; f++){
      if(FN.contactForm.fileAttachments[f].name === fileName){
        FN.contactForm.fileAttachments.splice(f, 1);
        FN.contactForm.showAddedFiles();
        break;
      }
    }
  },


  showAddedFiles: function(){
    var fileList = $('.' + FN.contactForm.selectors.dragDropUploadClass).find('.box__files');
    var labelText = '<ul>';
    for(var f=0; f<FN.contactForm.fileAttachments.length; f++){
      labelText += '<li class="'+ FN.contactForm.selectors.dragDropUploadFileItemClass +'">';
      labelText += '<a class="'+FN.contactForm.selectors.dragDropUploadRemoveButtonClass+'">x</a>';
      labelText += '<span class="'+ FN.contactForm.selectors.dragDropUploadFileNameClass +'">' + FN.contactForm.fileAttachments[f].name + '</span> &nbsp;&nbsp;';
      labelText += '</li>';
    }
    labelText += '</ul>';

    $(fileList).html(labelText);
  },


  handleDragDropEvents: function() {
    if(!FN.contactForm.isAdvancedUpload()) return false;

    var dragDropElement = $('.' + FN.contactForm.selectors.dragDropUploadClass);
    var form = $(dragDropElement).closest('form');
    $(dragDropElement).addClass('has-advanced-upload' ); // CSS styling --> drag & drop is supported by the browser

    [ 'drag', 'dragstart', 'dragend', 'dragover', 'dragenter', 'dragleave', 'drop' ].forEach( function( event ){
      $(form).on(event, function(e){
        e.preventDefault();
        e.stopPropagation();
      });
    });

    [ 'dragover', 'dragenter' ].forEach( function( event ){
      $(dragDropElement).on(event, function(){
        $(this).addClass('is-dragover');
      });
    });

    [ 'dragleave', 'dragend', 'drop' ].forEach( function( event ){
      $(dragDropElement).on(event, function(){
        $(this).removeClass('is-dragover');
      });
    });

    $(dragDropElement).on('drop', function(event){
      FN.contactForm.addFiles(event.originalEvent.dataTransfer.files);
      FN.contactForm.showAddedFiles();
    });
  },


  isFormValid: function(){
    if (FN.contactForm.honeypotFilled()) {
      FN.contactForm.showStatus('error', FN.contactForm.constants.honeypotFilledMessage);
      return false;
    }

    // Check attachment size limit 10MB
    var totalSize = (FN.contactForm.fileAttachments || []).reduce(function(sum, file) {
      return sum + (file && file.size ? file.size : 0);
    }, 0);
    
    if (totalSize > 10 * 1024 * 1024) {
      FN.contactForm.showStatus('error', "Attachments exceed 10MB total size limit.");
      return false;
    }

    // Get the current form type
    var currentFormType = $('#form-type select').val();

    // For Bug Reports on Windows, check if there's at least one file attachment
    if(currentFormType === 'Bug Report') {
      // Check if we're on Windows (Mac class is hidden and Windows class is visible)
      var isMacVisible = $('.visible-on--mac:visible').length > 0;
      var isWindowsVisible = $('.visible-on--windows:visible').length > 0;

      // If we're on Windows (Windows is visible, Mac is not), require file attachments
      if(isWindowsVisible && !isMacVisible) {
        if(FN.contactForm.fileAttachments.length === 0) {
          FN.contactForm.showStatus('error', "Please attach log files (mandatory for Windows users).");
          return false;
        }
      }
    }

    // check every 'required' field
    for(var i=0; i<FN.contactForm.constants.requiredFields.length; i++){
      var fieldName = FN.contactForm.constants.requiredFields[i];

      var selector = '#' + FN.contactForm.selectors.formId + " [name='"+ FN.contactForm.constants.requiredFields[i] +"']";
      var field = $(selector);

      if($(field).is('input[type="text"]') || $(field).is('textarea')){
        //----- text input // textarea
        var fieldVal = $(field).val();
        if(fieldVal === ""){
          // a required field is empty!
          FN.contactForm.showStatus('error', FN.contactForm.constants.incompleteMessage);
          return false;
        }

        if(FN.contactForm.constants.requiredFields[i] === 'email'){
    		  var emailFilter = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      		// check email address
      		if (!(emailFilter.test(fieldVal))) {
    			  FN.contactForm.showStatus('error', FN.contactForm.constants.invalidEmailMessage);
        		return false;
      		}
        }

      }else if($(field).is('input[type="checkbox"]')){
        //----- checkboxes
        var checked = $(field).prop('checked');
        if(!checked) {
          if(FN.contactForm.constants.requiredFields[i] === 'legal'){
            FN.contactForm.showStatus('error', FN.contactForm.constants.acceptPrivacyPolicyMessage);
          }else{
            FN.contactForm.showStatus('error', FN.contactForm.constants.incompleteMessage);
          }
          return false;
        }
      }
    }
    return true;
  },


  honeypotFilled: function () {
    $field = $(FN.contactForm.selectors.honeypotSelector);
    val = $field.val();
    return val !== "";
  },


  isAdvancedUpload: function(){
		var div = document.createElement( 'div' );
		return ( ( 'draggable' in div ) || ( 'ondragstart' in div && 'ondrop' in div ) ) && 'FormData' in window && 'FileReader' in window;
	},


  showStatus: function(status, message){
    var messageContainer = $('.' + FN.contactForm.selectors.statusMessageClass);
    messageContainer.removeClass('error progress success').addClass(status).html(message).show();
  },


  showIntro: function(formTypeIdentifier){
    var introText = false;
    var towerVersionParameter = FN.helpers.getURLParameterByName('tower_version');

    if(!towerVersionParameter && (formTypeIdentifier === 'Support Question' || formTypeIdentifier === 'Bug Report')){
      introText   = '<p><strong>Did you know?</strong> Choosing "<b>Contact Customer Support</b>" from Tower\'s <b>Help</b> menu will prefill the contact form for you!</p>';
      introText  += '<img class="visible-on--mac" src="'+ FN.config.urls.base +'assets/img/contact-form-prefill-tip_mac.png"><img class="visible-on--windows" src="'+ FN.config.urls.base +'assets/img/contact-form-prefill-tip_mac.png">';
    }

    $('#form-intro').html(introText);
    FN.osSwitch.toggleContent();
    $('#form-intro').show();
  },


  prefillFormFields: function(){
    $('input[name="name"]').val(FN.helpers.getURLParameterByName('name'));
    $('input[name="email"]').val(FN.helpers.getURLParameterByName('email'));
    $('input[name="git_version"]').val(FN.helpers.getURLParameterByName('git_version'));
    $('input[name="tower_version"]').val(FN.helpers.getURLParameterByName('tower_version'));
    $('input[name="machine-id"]').val(FN.helpers.getURLParameterByName('machine_identifier'));
    $('input[name="os_version"]').val(FN.helpers.getURLParameterByName('os_version'));
    if(FN.helpers.getURLParameterByName('tower_plan')){
      $('select[name="tower_plan"] option').each(function(index, item){
        if($(this).data('plan-uuid') === FN.helpers.getURLParameterByName('tower_plan')){
          $(this).prop('selected', true);
          return false;
        }
      });
    }
    if(!FN.helpers.getURLParameterByName('os_name')){
      if(FN.helpers.platform() == "mac") $('select[name="os_name"]').val('mac');
    }else{
      $('select[name="os_name"]').val(FN.helpers.getURLParameterByName('os_name'));
    }
  },


  formConfigWithType: function(formTypeIdentifier){
    for(var i=0; i<FN.contactForm.contactTypes.length; i++){
      if(FN.contactForm.contactTypes[i].type === formTypeIdentifier){
        return FN.contactForm.contactTypes[i];
      }
    }
    return false;
  },


  prepareFormData: function(){
    var formData = false;
    var form = $('#' + FN.contactForm.selectors.formId);

    if(FN.contactForm.isAdvancedUpload()){
      // remove the "old-school" file input --> we have all file data in our GT.contact.fileAttachments array
      $(form).find('input[type="file"]').remove();
      // gathering the form data
      var formData = new FormData(form[0]);
      if(FN.contactForm.fileAttachments){
        for(var f=0; f<FN.contactForm.fileAttachments.length; f++){
          formData.append('files[]', FN.contactForm.fileAttachments[f]);
        }
      }
      return formData;

    }else{
      // form preparation in the case of a classic page request
    }
  },


  submitForm: function(formEl, event){
    $('input[type="submit"]').attr('disabled', 'disabled');
    FN.contactForm.showStatus('progress', FN.contactForm.constants.sendingMessage);

    // ajax file upload for modern browsers
    if(FN.contactForm.isAdvancedUpload()){
      var form = $('#' + FN.contactForm.selectors.formId);
      var formData = FN.contactForm.prepareFormData();

      // ajax request
      $.ajax({
        url: $(form).attr('action'),
        data: formData,
        dataType: 'json',
        processData: false,
        contentType: false,
        type: 'POST',
        success: function(data){
          FN.contactForm.handleFormResponse(data);
        },
      })
      .fail(function(){
        FN.contactForm.showStatus('error', FN.contactForm.constants.errorMessage);
        $('input[type="submit"]').removeAttr('disabled');
      });

    }else{
      // classic page request
      return true;
    }
  },


  handleFormResponse: function(responseData){
    var redirectURL = false;
    if(responseData['status'] < 400){
      FN.contactForm.showStatus('success', FN.contactForm.constants.successMessage);
      redirectURL = FN.config.urls.base + FN.config.urls.ticketSupportSuccess;

    }else if(responseData['status'] >= 400){
      FN.contactForm.showStatus('error', FN.contactForm.constants.errorMessage);
      redirectURL = FN.config.urls.base + 'error';
    }
    window.location = redirectURL;
  },


  initHelpSuggestions: function(){
    $('#form-subject').on('keyup', function(){
      if(FN.contactForm.requestTimeout) clearTimeout(FN.contactForm.requestTimeout);
      FN.contactForm.requestTimeout = setTimeout(function(){
        FN.contactForm.requestHelpSuggestion();
      }, 500);
    });
  },


  requestHelpSuggestion: function(){
    var textInput = $('input[name="subject"]').val();
    if(textInput.length < 2) return;

    // request suggestions from Help Search
    var helpSearchUrl = (FN.helpers.platform() == 'mac') ? FN.config.urls.helpSearchMac : FN.config.urls.helpSearchWindows;
    $.ajax({
      method: "GET",
      url: helpSearchUrl,
      data: {format: 'json', search: textInput, limit: 10},
      dataType: 'json'
    })
    .done(function( data ) {
      FN.contactForm.showHelpSuggestion(data, textInput);
    });
  },


  showHelpSuggestion: function(data, searchTerm) {
    if(!'results' in data || data.results.length == 0) return;

    var html = '<h5>Suggested Help Articles</h5>';
    html += '<ul>';
    for(var i=0; i<data.results.length; i++){
      var helpUrl = data.results[i]['url'];
      helpUrl += (helpUrl.indexOf('?') == -1) ? '?' : '&';
      helpUrl += 'utm_source=' + FN.contactForm.helpSuggestions.utmLinking.source + '&utm_campaign=' + FN.contactForm.helpSuggestions.utmLinking.campaign + '&utm_medium=' + FN.contactForm.helpSuggestions.utmLinking.medium + '&utm_term=' + encodeURIComponent(searchTerm);

      html += '<li><a href="'+ helpUrl + '" target="_blank">' + data.results[i]['title'] + '</a></li>';
    }
    html += '</ul>';

    $('#form-help-suggestions .contact-form__content').html(html);
    $('#form-help-suggestions').show();
  }
};




$(document).ready(function(){
  FN.contactForm.init();
});
